import { HTTPResponse } from '@spotify-internal/transport';

import { ErrorResponse } from '@spotify-internal/ads-api-typescript-client';

// As of Oct 2023, Ads API cannot add both error response types to
// the TS client, even though the API may respond in either, depending
// on the scenario. It only supports one. Manually adding the other here.
// https://spotify.slack.com/archives/C02PM251U72/p1696368761097649?thread_ts=1696361416.429709&cid=C02PM251U72
export type AdsApiErrorResponse = Partial<{
  detail: string;
  instance: string;
  status: number;
  title: string;
  type: string;
}> &
  ErrorResponse;

/**
 * Function to uniformly handle Ads API response bodies and errors.
 *
 * @param res Response object directly from Transport request
 * @returns Expected response body, or throws error if request not ok
 */
export function getAdsApiResponse<T>(
  res: HTTPResponse<Partial<T & AdsApiErrorResponse>>,
) {
  if (!res.ok) {
    // Ads API may respond with two different error response types.
    // See the type for AdsApiErrorResponse for more details.
    const errorMessage = res.body?.detail || res.body?.messages?.join(',');
    return errorMessage;
  }

  return res.body;
}
